import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { NavigationConfig } from '../utils/navigation-constants';
import { VerifyLoginOtp } from '../pages/login/login-otp';
import PasswordSetup from '../pages/login/password-setup';
import { Login } from '../pages/login/login';
import { ForgotPassword } from '../pages/login/forgot-password';

const Routing: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path={NavigationConfig.Login} element={<Login />} />
            <Route path={NavigationConfig.ForgotPassword} element={<ForgotPassword />} />
            <Route path={NavigationConfig.LoginOtpScreen} element={<VerifyLoginOtp />} />
            <Route path={NavigationConfig.PasswordSetup} element={<PasswordSetup />} />
            <Route path="*" element={<Login />} />
        </Routes>
    );
};
export { Routing };
